import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EncryptDutyFreePreorderResultEffect } from './encrypt-duty-free-preorder-result.effect';
import { encryptDutyFreePreorderResultReducer } from './encrypt-duty-free-preorder-result.reducer';
import {
  ENCRYPT_DUTY_FREE_PREORDER_RESULT_STORE_NAME,
  EncryptDutyFreePreorderResultState,
} from './encrypt-duty-free-preorder-result.state';

/** Token of the EncryptDutyFreePreorderResult reducer */
export const ENCRYPT_DUTY_FREE_PREORDER_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<EncryptDutyFreePreorderResultState, Action>
>('Feature EncryptDutyFreePreorderResult Reducer');

/** Provide default reducer for EncryptDutyFreePreorderResult store */
export function getDefaultEncryptDutyFreePreorderResultReducer() {
  return encryptDutyFreePreorderResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(
      ENCRYPT_DUTY_FREE_PREORDER_RESULT_STORE_NAME,
      ENCRYPT_DUTY_FREE_PREORDER_RESULT_REDUCER_TOKEN
    ),
    EffectsModule.forFeature([EncryptDutyFreePreorderResultEffect]),
  ],
  providers: [
    {
      provide: ENCRYPT_DUTY_FREE_PREORDER_RESULT_REDUCER_TOKEN,
      useFactory: getDefaultEncryptDutyFreePreorderResultReducer,
    },
  ],
})
export class EncryptDutyFreePreorderResultStoreModule {
  public static forRoot<T extends EncryptDutyFreePreorderResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<EncryptDutyFreePreorderResultStoreModule> {
    return {
      ngModule: EncryptDutyFreePreorderResultStoreModule,
      providers: [{ provide: ENCRYPT_DUTY_FREE_PREORDER_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
